import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/marketing/mobile-tips.svg'


const _withScopeId = n => (_pushScopeId("data-v-209fe45c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading-container"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "btn-footer" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "tips-content"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "tips-content_title"
}
const _hoisted_8 = {
  key: 1,
  class: "tips-content_subtitle"
}
const _hoisted_9 = {
  key: 2,
  class: "tips-content_subtitle"
}

import { ref, reactive, toRaw, computed, onBeforeMount } from 'vue'
import { useRoute } from 'vue-router'
import { useTitle } from '@vueuse/core'
import CustomerArea from '@/components/CustomerArea/index'
import { customerTypeEnum, genderEnum, linkRoleTypeEnum } from '@/views/marketing/commonEnum/dataConfig'
import templateFields from '@/utils/templateFields'
import { templateDetail, clueActivityAdd, activityDetail } from '@/api/marketing/marketingManage'
import { useEnum } from './components/useEnum'
import type { FormInstance } from 'ant-design-vue'

const __default__ = { name: 'DcCosZbuQrcodeMobile' }

interface TemplateData {
  background?: string
  config?: any[]
  globalConfig?: any
}
interface TemplateForm {
  customerName?: string
  channel?: number
  customerOffice?: string
  customerType?: number
  customerTag?: string
  remark?: string
  contact: {
    name?: string
    sex?: number
    jobRole?: number
    mobile?: string
    email?: string
    wechat?: string
    qq?: string
    tel?: string
    remark?: string
  }
  business: {
    cargoType?: number
    salePlatform?: number
    warehouse?: number
    shipAddress?: string
    salesCategory?: string
    monthSales?: number
    destinationCountry?: string
    requiredServices?: string
    serviceNeeds?: number
    cooperation?: number
  }
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const title = useTitle()
const { paramCodeData, tagListEnum, getByParamCodes, getTagList } = useEnum()

const loadingPage = ref(false) // 页面加载动画
const finishPage = ref(false) // 活动是否已经结束
const isFormPage = ref(false) // 是否是表单页面
const successPage = ref(false) // 是否提交成功页面
const getActivityDetails = (): Promise<boolean> => {
  loadingPage.value = true
  return new Promise((resolve, reject) => {
    activityDetail({ activityQrcodeId: qrcodeId.value })
      .then(({ data }) => {
        if (data == null) return resolve(false)
        title.value = data.activityName
        const curTime = new Date().getTime()
        const endTime = new Date(data.endTime).getTime()
        if (!data.enableFlag || curTime > endTime) {
          // 活动已结束
          isFormPage.value = false
          finishPage.value = true
          resolve(false)
        } else {
          isFormPage.value = true
          resolve(true)
        }
      })
      .catch((err) => {
        reject(err)
      })
      .finally(() => {
        loadingPage.value = false
      })
  })
}

const fieldsFlatAll = templateFields.reduce((arr: any, item) => {
  arr = [...arr, ...item.options]
  return arr
}, [])
const previewForm = ref<any[]>([])

// const isAgreeChecked = ref(false)
const dataForm: TemplateForm = reactive({ contact: {}, business: {} })
const qrcodeId = computed(() => route.query.qrcodeId as string)
const templateId = computed(() => parseInt(route.query.templateId as string))
const templateData: TemplateData = reactive({})
const successImages = computed(() => {
  return templateData.globalConfig?.successImages.map((item: any) => item.url) || []
})
const getTemplateDetail = () => {
  templateDetail({ templateId: templateId.value }).then((res) => {
    res.data.config = JSON.parse(res.data.config as string)
    res.data.globalConfig = JSON.parse(res.data.globalConfig as string)
    Object.assign(templateData, res.data)

    const list = templateData.config?.map((item) => {
      const fieldItem = fieldsFlatAll.find((e: any) => e.field === item.field)
      return Object.assign({}, fieldItem, {
        label: item.label || fieldItem?.label || '',
        required: item.required,
        checked: toRaw(item.checked) || undefined
      })
    })
    previewForm.value = list || []
  })
}
onBeforeMount(async () => {
  const flag = await getActivityDetails()
  if (!flag) return
  await getTagList()
  await getByParamCodes('fbu')
  getTemplateDetail()
})

const isExpand = ref<boolean>(false)
const handleExpand = (type: 'img' | 'form') => {
  if (type === 'img' && isExpand.value) isExpand.value = false
  if (type === 'form' && !isExpand.value) isExpand.value = true
}

// const visible = ref<boolean>(false)
// const showModal = () => {
//   visible.value = true
// }
// const handleOk = (e: MouseEvent) => {
//   console.log(e)
//   isAgreeChecked.value = true
//   visible.value = false
// }

const loading = ref(false)
const formRef = ref<FormInstance>()
const submit = async () => {
  // if (!isAgreeChecked.value) {
  //   return message.warning('请先阅读并同意隐私协议')
  // }
  try {
    const values = await formRef.value?.validateFields()
    const params = Object.assign({}, toRaw(values), {
      activityQrcodeId: qrcodeId.value
    })
    loading.value = true
    clueActivityAdd(params)
      .then(() => {
        // 提交成功
        isFormPage.value = false
        successPage.value = true
      })
      .finally(() => {
        loading.value = false
      })
  } catch (errorInfo) {
    console.log('Failed:', errorInfo)
  }
}
const handleCancel = () => {
  window.close()
}

// 过滤下拉框选项
const customSelectOption = (oldList: any[], newList?: number[] | string[]) => {
  if (oldList == null) return []
  if (newList == null || newList.length === 0) return oldList || []
  const list = newList.map((item) => {
    const find = oldList.find((e: any) => e.id === item || e.value === item)
    return toRaw(find)
  })
  return list.filter((e) => e != null) || []
}

return (_ctx: any,_cache: any) => {
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["mobile-container", { 'has-tips': !isFormPage.value }])
  }, [
    (loadingPage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_a_spin)
        ]))
      : _createCommentVNode("", true),
    (isFormPage.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", {
            class: "picture",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleExpand('img')))
          }, [
            _createElementVNode("img", {
              src: templateData.background
            }, null, 8, _hoisted_2)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["form-content", { 'is-expand': isExpand.value }]),
            onClick: _cache[25] || (_cache[25] = ($event: any) => (handleExpand('form')))
          }, [
            _createVNode(_component_a_form, {
              ref_key: "formRef",
              ref: formRef,
              colon: false,
              labelAlign: "left",
              model: dataForm,
              autocomplete: "off"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(previewForm.value, (item, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (item.field === 'customerName')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 0,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: "customerName",
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.customerName,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dataForm.customerName) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 100,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'customerOffice')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 1,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: "customerOffice",
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(CustomerArea), {
                              value: dataForm.customerOffice,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((dataForm.customerOffice) = $event)),
                              "change-on-select": "",
                              allowClear: "",
                              placeholder: `请选择${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'customerType')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 2,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: "customerType",
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: dataForm.customerType,
                              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((dataForm.customerType) = $event)),
                              options: customSelectOption(_unref(customerTypeEnum), item.checked),
                              allowClear: "",
                              placeholder: `请选择${item.label}`
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'customerTag')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 3,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: "customerTag",
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: dataForm.customerTag,
                              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((dataForm.customerTag) = $event)),
                              options: customSelectOption(_unref(tagListEnum), item.checked),
                              mode: "multiple",
                              allowClear: "",
                              placeholder: `请选择${item.label}`,
                              fieldNames: { label: 'name', value: 'name' }
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'remark')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 4,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: "remark",
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              value: dataForm.remark,
                              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((dataForm.remark) = $event)),
                              maxlength: 2000,
                              placeholder: `请输入${item.label}`,
                              rows: 2
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'contact.name')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 5,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['contact', 'name'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.contact.name,
                              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((dataForm.contact.name) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 100,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'contact.sex')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 6,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: ['contact', 'sex'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: dataForm.contact.sex,
                              "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((dataForm.contact.sex) = $event)),
                              options: customSelectOption(_unref(genderEnum), item.checked),
                              allowClear: "",
                              placeholder: `请选择${item.label}`
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'contact.jobRole')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 7,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: ['contact', 'jobRole'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: dataForm.contact.jobRole,
                              "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((dataForm.contact.jobRole) = $event)),
                              options: customSelectOption(_unref(linkRoleTypeEnum), item.checked),
                              allowClear: "",
                              placeholder: `请选择${item.label}`
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'contact.mobile')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 8,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['contact', 'mobile'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.contact.mobile,
                              "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((dataForm.contact.mobile) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 100,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'contact.email')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 9,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['contact', 'email'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.contact.email,
                              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((dataForm.contact.email) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 100,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'contact.wechat')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 10,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['contact', 'wechat'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.contact.wechat,
                              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((dataForm.contact.wechat) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 100,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'contact.qq')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 11,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['contact', 'qq'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.contact.qq,
                              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((dataForm.contact.qq) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 100,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'contact.tel')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 12,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['contact', 'tel'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.contact.tel,
                              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((dataForm.contact.tel) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 100,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'contact.remark')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 13,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['contact', 'remark'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_textarea, {
                              value: dataForm.contact.remark,
                              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((dataForm.contact.remark) = $event)),
                              maxlength: 2000,
                              placeholder: `请输入${item.label}`,
                              rows: 2
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.cargoType')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 14,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: ['business', 'cargoType'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ParamCodesSelect, {
                              value: dataForm.business.cargoType,
                              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((dataForm.business.cargoType) = $event)),
                              options: customSelectOption(_unref(paramCodeData).zbu_product_type, item.checked),
                              allowClear: "",
                              placeholder: `请选择${item.label}`,
                              mode: "multiple"
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.salePlatform')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 15,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: ['business', 'salePlatform'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ParamCodesSelect, {
                              value: dataForm.business.salePlatform,
                              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((dataForm.business.salePlatform) = $event)),
                              options: customSelectOption(_unref(paramCodeData).zbu_channel_detail, item.checked),
                              allowClear: "",
                              placeholder: `请选择${item.label}`,
                              mode: "multiple"
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.warehouse')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 16,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: ['business', 'warehouse'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ParamCodesSelect, {
                              value: dataForm.business.warehouse,
                              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((dataForm.business.warehouse) = $event)),
                              options: customSelectOption(_unref(paramCodeData).zbu_demand_info, item.checked),
                              allowClear: "",
                              placeholder: `请选择${item.label}`,
                              mode: "multiple"
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.shipAddress')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 17,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['business', 'shipAddress'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.business.shipAddress,
                              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((dataForm.business.shipAddress) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.salesCategory')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 18,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['business', 'salesCategory'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.business.salesCategory,
                              "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => ((dataForm.business.salesCategory) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.monthSales')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 19,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: ['business', 'monthSales'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ParamCodesSelect, {
                              value: dataForm.business.monthSales,
                              "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((dataForm.business.monthSales) = $event)),
                              options: customSelectOption(_unref(paramCodeData).zbu_monthly_sales, item.checked),
                              allowClear: "",
                              placeholder: `请选择${item.label}`,
                              mode: "multiple"
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.destinationCountry')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 20,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['business', 'destinationCountry'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.business.destinationCountry,
                              "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => ((dataForm.business.destinationCountry) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 100,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.requiredServices')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 21,
                          rules: [{ required: item.required, message: `请输入${item.label}` }],
                          name: ['business', 'requiredServices'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              value: dataForm.business.requiredServices,
                              "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((dataForm.business.requiredServices) = $event)),
                              valueModifiers: { trim: true },
                              maxlength: 200,
                              allowClear: "",
                              placeholder: `请输入${item.label}`
                            }, null, 8, ["value", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.serviceNeeds')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 22,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: ['business', 'serviceNeeds'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ParamCodesSelect, {
                              value: dataForm.business.serviceNeeds,
                              "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((dataForm.business.serviceNeeds) = $event)),
                              options: customSelectOption(_unref(paramCodeData).zbu_service_demand, item.checked),
                              allowClear: "",
                              placeholder: `请选择${item.label}`,
                              mode: "multiple"
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true),
                    (item.field === 'business.cooperation')
                      ? (_openBlock(), _createBlock(_component_a_form_item, {
                          key: 23,
                          rules: [{ required: item.required, message: `请选择${item.label}` }],
                          name: ['business', 'cooperation'],
                          label: item.label
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ParamCodesSelect, {
                              value: dataForm.business.cooperation,
                              "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((dataForm.business.cooperation) = $event)),
                              options: customSelectOption(_unref(paramCodeData).zbu_existing_cooperation, item.checked),
                              allowClear: "",
                              placeholder: `请选择${item.label}`,
                              mode: "multiple"
                            }, null, 8, ["value", "options", "placeholder"])
                          ]),
                          _: 2
                        }, 1032, ["rules", "label"]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
              ]),
              _: 1
            }, 8, ["model"])
          ], 2),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_button, {
              type: "primary",
              block: "",
              size: "large",
              loading: loading.value,
              onClick: _cache[26] || (_cache[26] = ($event: any) => (submit()))
            }, {
              default: _withCtx(() => [
                _createTextVNode("提交")
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ], 64))
      : _createCommentVNode("", true),
    (finishPage.value || successPage.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (successImages.value.length)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(successImages.value, (img, index) => {
                return (_openBlock(), _createElementBlock("img", {
                  class: "success-images",
                  key: index,
                  src: img
                }, null, 8, _hoisted_4))
              }), 128))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _hoisted_6,
                (successPage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_7, "提交成功！"))
                  : _createCommentVNode("", true),
                (successPage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, "稍后会有顾问与您联系"))
                  : _createCommentVNode("", true),
                (finishPage.value)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, "活动已结束，感谢您的关注"))
                  : _createCommentVNode("", true),
                _createVNode(_component_a_button, {
                  type: "primary",
                  shape: "round",
                  size: "large",
                  loading: loading.value,
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (handleCancel()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("关闭")
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ], 2))
}
}

})